import React, { useState } from "react";
import "./Messages.css"; // Make sure the path is correct
import StatusBar from "../StatusBar/StatusBar";
import Chat from "./Chat/chat";
import { Chat_content } from "./MessagesInterfaces";
import GramLogo from "../../Components/TheGramApp/MMC_Phone App_TheGram.svg";
import GramHomeButton from "../../Components/TheGramApp/MMC_Phone App_TheGram_Home.svg";
import GramDmButton from "../../Components/TheGramApp/MMC_Phone App_TheGram_DM.svg";

type MessagesProps = {
  influencerMessageContent: Chat_content[];
  theGram: boolean;
  handleStateChange?: (chat: Chat_content) => void;
  handleHomeClick?: () => void;
};

const Messages: React.FC<MessagesProps> = ({
  influencerMessageContent,
  theGram,
  handleStateChange,
  handleHomeClick,
}) => {
  const messages = influencerMessageContent;
  // This is the same as influencerMessageContent
  const [showOverlay, setShowOverlay] = useState(false);
  const [selectedChat, setSelectedChat] = useState<Chat_content | null>(null);

  const handleClick = (chat: Chat_content) => {
    // Find the index of the clicked chat

    // Create a new array and update the read property of the clicked chat
    if (handleStateChange) {
      handleStateChange(chat);
    }

    setSelectedChat(chat);
    setShowOverlay(true);
  };

  const handleClose = (event: React.MouseEvent) => {
    event.stopPropagation();
    setShowOverlay(false);
  };

  return (
    <div className={`messages-app`}>
      <div className="messages-app-status-bar">
        <StatusBar />
      </div>
      {theGram ? (
        <div className="thegram-app-header">
          <div className="thegram-home-button">
            <button
              onClick={() => handleHomeClick && handleHomeClick()}
              style={{ background: "none", border: "none" }}
            >
              <img
                src={GramHomeButton}
                alt="Direct Message"
                className="dm-button"
                style={{ width: "40px", height: "40px" }} // Adjust the width and height as desired
              />
            </button>
          </div>
          <div className="thegram-app-title">
            <img
              src={GramLogo}
              alt="TheGram Logo"
              className="thegram-logo"
              style={{ height: "40px" }}
            />
          </div>
          <div className="message-button">
            <button
              className="dm-button"
              style={{ background: "none", border: "none" }}
            >
              <img
                src={GramDmButton}
                alt="Direct Message"
                style={{ width: "40px", height: "40px" }} // Adjust the width and height as desired
              />
            </button>
          </div>
        </div>
      ) : (
        <div className="messages-app-header">
          <div className="messages-app-title">
            <h1>Messages</h1>
          </div>
        </div>
      )}
      <div className="chats-list-body">
        <div className="chats-list">
          {messages.map((chat, index) => (
            <Chat
              key={index}
              chat_content={chat}
              onClick={() => handleClick(chat)}
            />
          ))}
        </div>
      </div>
      {showOverlay && (
        <div className="Overlay-chat">
          <div className="messages-app-status-bar">
            <StatusBar />
          </div>
          <div className="Overlay-chat-header">
            <button onClick={handleClose} className="Overlay-close-button">
              {" "}
              &lt; Back{" "}
            </button>

            <div className="Overlay-chat-title">
              {typeof selectedChat?.icon === "string" ? (
                <img
                  src={selectedChat?.icon}
                  alt="icon"
                  className="Overlay-chat-icon"
                />
              ) : (
                selectedChat?.icon && (
                  <selectedChat.icon className="Overlay-chat-icon" />
                )
              )}
              <h1>{selectedChat?.name}</h1>
            </div>
          </div>
          <div className="Overlay-chat-content">
            {selectedChat?.type === "individual" &&
              selectedChat.messages.map((message, index) => {
                const messageDate = new Date(
                  message.timestamp
                ).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                  timeZone: "UTC",
                });

                const previousMessage = selectedChat.messages[index - 1];
                const previousMessageDate = previousMessage
                  ? new Date(previousMessage.timestamp).toLocaleDateString(
                      "en-US",
                      {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                        timeZone: "UTC",
                      }
                    )
                  : null;

                return (
                  <React.Fragment key={index}>
                    {messageDate !== previousMessageDate && (
                      <div className="date-separator">
                        <h4>{messageDate}</h4>
                      </div>
                    )}
                    {message.content.type === "text" ? (
                      <div
                        className={`message-container ${
                          message.from === "Josh" ||
                          message.from === "Dolphin" ||
                          message.from === "George" ||
                          message.from === "Noémie" ||
                          message.from === "Shauna" ||
                          message.from === "self" ||
                          message.from === "Arabella" ||
                          message.from === "Me" ||
                          message.from === "Nancy"
                            ? "self"
                            : "from"
                        }`}
                      >
                        <p
                          className={`message-bubble ${
                            message.from === "Josh" ||
                            message.from === "Dolphin" ||
                            message.from === "George" ||
                            message.from === "Noémie" ||
                            message.from === "Shauna" ||
                            message.from === "self" ||
                            message.from === "Arabella" ||
                            message.from === "Me" ||
                            message.from === "Nancy"
                              ? "message-to"
                              : "message-from"
                          }`}
                        >
                          {message.content.content}
                        </p>
                        <span
                          className="timestamp"
                          style={{ textAlign: "left" }}
                        >
                          {message.from}
                          {"   "}
                          {new Date(message.timestamp).toLocaleString("en-US", {
                            hour: "numeric",
                            minute: "numeric",
                            hour12: true,
                            timeZone: "UTC",
                          })}
                        </span>
                      </div>
                    ) : message.content.type === "missed-call" ? (
                      <div
                        key={index}
                        className={`message-container missed-call `}
                      >
                        <p className={`message-bubble missed-call `}>
                          {message.content.content}
                        </p>
                        {/* <span className="timestamp">
                          {new Date(message.timestamp).toLocaleString("en-US", {
                            hour: "numeric",
                            minute: "numeric",
                            hour12: true,
                          })}
                        </span> */}
                      </div>
                    ) : message.content.type === "photo" ? (
                      <div
                        key={index}
                        className={`message-container photo ${
                          message.from === "Josh" ||
                          message.from === "Dolphin" ||
                          message.from === "George" ||
                          message.from === "Noémie" ||
                          message.from === "Shauna" ||
                          message.from === "self" ||
                          message.from === "Nancy" ||
                          message.from === "Arabella" ||
                          message.from === "Me"
                            ? "self"
                            : "from"
                        }`}
                      >
                        <img
                          className={`message-bubble photo ${
                            message.from === "Josh" ||
                            message.from === "Dolphin" ||
                            message.from === "George" ||
                            message.from === "Noémie" ||
                            message.from === "Shauna" ||
                            message.from === "Nancy" ||
                            message.from === "Arabella" ||
                            message.from === "Me"
                              ? "message-to"
                              : "message-from"
                          }`}
                          src={message.content.content.image}
                          alt="loading..."
                        ></img>
                        <span className="timestamp">
                          {new Date(message.timestamp).toLocaleString("en-US", {
                            hour: "numeric",
                            minute: "numeric",
                            hour12: true,
                            timeZone: "UTC",
                          })}
                        </span>
                      </div>
                    ) : null}
                  </React.Fragment>
                );
              })}
          </div>
        </div>
      )}
    </div>
  );
};

export default Messages;
